import { type TreeId, type GroupDetails } from '@fs/zion-tree-types'
import axios, { type AxiosResponse } from '@fs/zion-axios'

type EditGroupProps = {
  currentGroup: GroupDetails
  name: string
  description: string
}

/**
 * @throws 400 - The group id was invalid.
 * @throws 400 - name cannot be empty.
 * @throws 400 - Invalid character or too many characters in a property.
 * @throws 403 - Only group admins can update group admin properties.
 * @throws 404 - Group not found.
 */
export function editGroup({ currentGroup, name, description }: EditGroupProps): ReturnType<typeof axios.post<''>> {
  const body = { codeOfConduct: currentGroup.codeOfConduct, description, name, types: currentGroup.types }
  return axios.post<''>(`/service/tree/tree-data/groups/${currentGroup.id}`, body).then((response) => {
    const treeId = currentGroup.treeIds?.[0]
    if (treeId) {
      updateTreeDetails(treeId, { name, description })
    }
    return response
  })
}

export function updateTreeDetails(
  treeId: TreeId,
  treeInfo: { name?: string; description?: string }
): Promise<AxiosResponse<''> | void> {
  const body = treeInfo
  // We want to catch all errors and do nothing since we don't have to tell the user something went wrong with updating the tree.
  // If the group details throws errors then we will show them the error for that.
  return axios.post<''>(`/service/tree/tree-data/groups/trees/${treeId}`, body).catch(console.error)
}
